import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Account => ');

const fetchCurrentAccount = createAction('fetch current account');
const fetchCurrentAccountSuccess = createAction('fetch current account success', (account) => ({ account }));
const fetchCurrentAccountFailure = createApiFailureAction('fetch current account failure');

const saveCurrentAccount = createAction('save current account', (accountSettings) => ({ accountSettings }));
const saveCurrentAccountSuccess = createAction('save current account success', (account) => ({ account }));
const saveCurrentAccountFailure = createApiFailureAction('save current account failure');

const updateCurrentAccountProperty = createAction('update active account property', (id, value) => ({ id, value }));

const fetchRelativeAccounts = createAction('fetch relative accounts');
const fetchRelativeAccountsSuccess = createAction('fetch relative accounts success', (accountList) => ({
  accountList,
}));
const fetchRelativeAccountsFailure = createApiFailureAction('fetch relative accounts failure');

export default {
  fetchCurrentAccount,
  fetchCurrentAccountSuccess,
  fetchCurrentAccountFailure,

  saveCurrentAccount,
  saveCurrentAccountSuccess,
  saveCurrentAccountFailure,
  updateCurrentAccountProperty,

  fetchRelativeAccounts,
  fetchRelativeAccountsSuccess,
  fetchRelativeAccountsFailure,
};
